import React, { FC } from "react";


export const Style:
    FC<
        React.DetailedHTMLProps<
            React.StyleHTMLAttributes<HTMLStyleElement>,
            HTMLStyleElement
        > &
        {
            id?: string;
            content?: string;
        }
    > =
    ({ id, content, children, ...props }) =>
    {
        return React.createElement("style", { id, dangerouslySetInnerHTML: { __html: content ?? children }, ...props });
    };
